import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Bet } from "@models";

export const Description = observer(function Description(props: { bet: Bet }) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">
				{t("ACC_STATEMENT.BET_DETAILS.ADDITIONAL_DESC")}
			</div>
			<div className="bet__details__col">
				{bet.formattedBetSystemString}
			</div>
		</div>
	);
});
